/**
 * ScrollToTop — resets window scroll to the top on every route change.
 *
 * React Router preserves scroll position across client-side navigations, which
 * makes links land mid-page (e.g. at the bottom of the FAQ). Rendering this
 * inside the router fixes it app-wide. Keyed on pathname only, so in-page hash
 * links still work.
 *
 * @module components/ScrollToTop
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
